import { DataStatus, MetricState } from 'models'

type MetricStatus = DataStatus | MetricState

// A metric whose recompute failed still holds its last good numbers, so we want it to look just
// like a healthy, READY metric. Read a FAILED state as READY and pass every other state through —
// for both metric-state types, DataStatus and MetricState.
export const normalizeMetricStatus = <T extends MetricStatus>(status: T): T =>
  status === DataStatus.Failed || status === MetricState.Failed ? (DataStatus.Ready as unknown as T) : status
